import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigurationService } from '@coreModule/services/configurationService';
import { InterceptorService } from '@coreModule/services/interceptorService';

@Injectable()
export class ChannelApplicationInterceptor implements HttpInterceptor {
  constructor(private interceptorService: InterceptorService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const channelApplication = ConfigurationService.appConfig?.assistance?.defaults?.channelApplication;
    const skipIntercept = this.interceptorService.skipInterceptor(req.url);
    if (!skipIntercept && channelApplication) {
      req = req.clone({
        headers: req.headers.set('channelApplication', channelApplication)
      });
    }
    return next.handle(req);
  }
}
